import {
  EMailFill24Icon,
  LinkOutOutline18Icon,
  PersonOutline24Icon,
  QuestionOutline18Icon,
  ThemeOutline24Icon,
} from "@vygruppen/spor-icon-react";
import { useAuth } from "app/Auth/AuthBoundary";
import { LanguageSwitch } from "features/Header/Menu/adminLinks/LanguageSwitch";
import {
  criticalErrorMailLink,
  otherErrorMailLink,
} from "features/Header/Menu/adminLinks/MailLink";
import { useTranslation } from "react-i18next";
import {
  Button,
  DropsButton,
  Flex,
  Switch,
  Text,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
  useColorMode,
} from "shared/components/Spor";

const AdminLinks = () => {
  const { colorMode, toggleColorMode } = useColorMode();
  const { t } = useTranslation();
  const { signOut } = useAuth();

  return (
    <Flex direction="column" my={3} mx={1.5} gap={3}>
      <Flex direction="column" gap={1}>
        <Flex gap={0.5} alignItems="center">
          <Text variant="sm" fontWeight={700}>
            {t("Tilbakemeldinger")}
          </Text>

          <Tooltip positioning={{ placement: "top" }}>
            <TooltipTrigger>
              <QuestionOutline18Icon />
            </TooltipTrigger>

            <TooltipContent showArrow maxWidth="250px">
              <Flex direction="column" gap={1.5}>
                <Flex direction="column">
                  <Text variant="sm" fontWeight={700}>
                    {t("Kritisk feil")}
                  </Text>
                  <Text variant="sm">
                    {t(
                      "Funksjoner er ikke brukbare og arbeidet stopper opp. Mail sendes til både Team DROPS og IT Servicesenter, og besvares fortløpende innen normal arbeidstid.",
                    )}
                  </Text>
                </Flex>

                <Flex direction="column">
                  <Text variant="sm" fontWeight={700}>
                    {t("Andre feil")}
                  </Text>
                  <Text variant="sm">
                    {t(
                      "Enkelte funksjoner er ikke brukbare, men det finnes midlertidige løsninger. Mail sendes kun til Team DROPS, og besvares innen normal arbeidstid.",
                    )}
                  </Text>
                </Flex>
              </Flex>
            </TooltipContent>
          </Tooltip>
        </Flex>

        <DropsButton
          asChild
          variant="tertiary"
          semantics="alarm"
          size="sm"
          leftIcon={<EMailFill24Icon color="semantics.colorAlarm" />}
          rightIcon={<LinkOutOutline18Icon />}
          width="100%"
        >
          <a
            href={criticalErrorMailLink(t)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Kritisk feil")}
          </a>
        </DropsButton>

        <DropsButton
          asChild
          variant="tertiary"
          semantics="warning"
          size="sm"
          leftIcon={<EMailFill24Icon color="semantics.colorWarning" />}
          rightIcon={<LinkOutOutline18Icon />}
          width="100%"
        >
          <a
            href={otherErrorMailLink(t)}
            target="_blank"
            rel="noopener noreferrer"
          >
            {t("Andre feil")}
          </a>
        </DropsButton>

        <Text variant="xs">
          {t(
            "NB! Ønsker og innspill deles med fagansvarlig i avd. som tar det videre til produkteier og utviklerteam.",
          )}
        </Text>
      </Flex>

      <Flex direction="column" gap={1}>
        <Text variant="sm" fontWeight={700}>
          {t("Preferanser")}
        </Text>

        <Flex direction="column" gap={1.5}>
          <LanguageSwitch />

          <Flex justifyContent="space-between">
            <Flex alignItems="center" gap={1}>
              <ThemeOutline24Icon />
              <Text>{t("Mørk modus")}</Text>
            </Flex>

            <Switch
              size="sm"
              checked={colorMode === "dark"}
              onChange={toggleColorMode}
              title={t("Mørk modus")}
            />
          </Flex>
        </Flex>
      </Flex>

      <Button
        variant="primary"
        size="sm"
        leftIcon={<PersonOutline24Icon />}
        width="100%"
        onClick={signOut}
        aria-label="Log out"
      >
        {t("Logg ut")}
      </Button>
    </Flex>
  );
};

export default AdminLinks;
